module.exports = __webpack_public_path__ + "static/accurkardia_bg_mobile-fba406f190032be1eaf7913355a04bcd.png";